module.exports = __webpack_public_path__ + "img/dark-cloudy.3a8bab19.svg";